import { createSelector, createFeatureSelector, ActionReducerMap } from '@ngrx/store';
import * as fromUser from './user.reducer';
import { ManagementModuleState } from '../';

export interface UserState {
  users: fromUser.State;
}

const selectManagementModuleState = createFeatureSelector<ManagementModuleState>('management');

const selectUserState = createSelector(selectManagementModuleState, (state: ManagementModuleState) => state?.users);

export const selectSelectedUser = createSelector(selectUserState, fromUser.getSelectedUser);

export const selectSelectedUIds = createSelector(selectUserState, fromUser.getSelectedUIds);

export const selectUsers = createSelector(selectUserState, fromUser.selectAll);

export const selectQueryParams = createSelector(selectUserState, fromUser.getQueryParams);

export const selectShowInviteForm = createSelector(selectUserState, fromUser.getShowInviteForm);

export const selectShowEditForm = createSelector(selectUserState, fromUser.getShowEditForm);

export const selectIsInviting = createSelector(selectUserState, fromUser.getIsInviting);

export const selectIsSubmitting = createSelector(selectUserState, fromUser.getIsSubmitting);

export const selectError = createSelector(selectUserState, fromUser.getError);

export const selectTotalUserCount = createSelector(selectUserState, fromUser.getTotalUserCount);

export const selectSearchTerm = createSelector(selectUserState, fromUser.getSearchTerm);
